import { createAsyncThunk } from '@reduxjs/toolkit'
import MessageAlert from 'app/components/MessageAlert'

import effects from 'app/effects/effects'
import { setCancelImportDialog } from '../importCSV'

const getSyncSetting = async ({ errorMessage, dispatch }) => {
  try {
    const response = await effects.apis.importExternalSource.getSyncSetting()
    const schoolSyncSetting = response?.data?.[0] || {}

    const syncEnabled = schoolSyncSetting.syncEnabled ?? false
    const lastImportDate = schoolSyncSetting.lastImportDate ?? null

    return { syncEnabled, lastImportDate }
  } catch (err) {
    console.error('error:', err)
    dispatch(
      MessageAlert.showError({
        message: errorMessage,
      }),
    )
    return { syncEnabled: false, lastImportDate: null }
  }
}

const getConnectedSISList = async (
  { errorMessage },
  { dispatch, isRejectedWithValue },
) => {
  try {
    const { syncEnabled, lastImportDate } = await getSyncSetting({
      errorMessage,
      dispatch,
    })

    const schoolData = await effects.apis.importExternalSource.getSISList()

    schoolData.syncEnabled = syncEnabled
    schoolData.lastImportDate = lastImportDate
    return schoolData
  } catch (err) {
    dispatch(
      MessageAlert.showError({
        message: errorMessage,
      }),
    )
    return isRejectedWithValue(err)
  }
}

export const getConnectedSISThunk = createAsyncThunk(
  'ConnectedSISList/get',
  getConnectedSISList,
)

const checkSISDataImport = async (
  { errorMessage, schoolId, isClickedImportBtn = false },
  { dispatch, getState, isRejectedWithValue },
) => {
  try {
    const { auth } = getState()
    const { id: currentUserId } = auth?.user?.data || {}
    const response =
      await effects.apis.importExternalSource.getSubscribersImportDetails()
    return { data: response, currentUserId, schoolId, isClickedImportBtn }
  } catch (err) {
    dispatch(
      MessageAlert.showError({
        message: errorMessage,
      }),
    )
    return isRejectedWithValue(err)
  }
}

export const checkSISDataImportThunk = createAsyncThunk(
  'connectedSISdataImport/check',
  checkSISDataImport,
)

const importSISData = async (data) => {
  return effects.apis.importExternalSource.importSubscribers(data)
}

export const importSISDataThunk = createAsyncThunk(
  'connectedSIS/import',
  importSISData,
)

const cancelImportSISData = async (
  { errorMessage },
  { getState, dispatch },
) => {
  try {
    const { importExternalSource } = getState()
    const { historyId } = importExternalSource.schoolImportProcessStatusData

    dispatch(setCancelImportDialog(null))
    if (historyId) {
      return await effects.apis.importCSV.cancelImport({ importId: historyId })
    }
  } catch (err) {
    errorMessage &&
      dispatch(
        MessageAlert.showError({
          message: errorMessage,
        }),
      )
  }
}

export const cancelImportSISDataThunk = createAsyncThunk(
  'importSISData/cancel',
  cancelImportSISData,
)

const enableAutoSync = async ({ errorMessage, data }, { dispatch }) => {
  try {
    return await effects.apis.importExternalSource.updateSyncSetting(data)
  } catch (err) {
    console.error('error:', err)
    errorMessage &&
      dispatch(
        MessageAlert.showError({
          message: errorMessage,
        }),
      )
  }
}

export const enableAutoSyncThunk = createAsyncThunk(
  'importSISData/enableAutoSync',
  enableAutoSync,
)
